import React, { useLayoutEffect, useRef, useState, useEffect } from "react";

const SmartPopup = ({ open, anchorEl, children, onClose, style = {} }) => {
  const popupRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const handleOutsideClick = (e) => {
      if (
        !popupRef.current?.contains(e.target) &&
        !anchorEl?.contains(e.target)
      ) {
        onClose?.();
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [open, anchorEl, onClose]);

  const [position, setPosition] = useState({
    top: 0,
    left: 0,
  });

  useLayoutEffect(() => {
    if (!open || !anchorEl || !popupRef.current) return;

    const anchor = anchorEl.getBoundingClientRect();
    const popup = popupRef.current.getBoundingClientRect();

    const gap = 5;
    const padding = 10;

    const spaceBelow = window.innerHeight - anchor.bottom;
    const spaceAbove = anchor.top;

    // Jis side zyada space hai, udhar open karo
    const openAbove = spaceBelow < popup.height && spaceAbove > spaceBelow;

    let top = openAbove ? anchor.top - popup.height - gap : anchor.bottom + gap;

    let left = anchor.left;

    // Right side se bahar na jaaye
    if (left + popup.width > window.innerWidth - padding) {
      left = window.innerWidth - popup.width - padding;
    }

    // Left side se bahar na jaaye
    if (left < padding) {
      left = padding;
    }

    // Top se bahar na jaaye
    if (top < padding) {
      top = padding;
    }

    // Bottom se bahar na jaaye
    if (top + popup.height > window.innerHeight - padding) {
      top = window.innerHeight - popup.height - padding;
    }

    setPosition({
      top,
      left,
    });
  }, [open, anchorEl, children]);

  if (!open) return null;

  return (
    <div
      ref={popupRef}
      style={{
        position: "fixed",
        top: position.top,
        left: position.left,
        zIndex: 99999,
        visibility:
          position.top === 0 && position.left === 0 ? "hidden" : "visible",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default SmartPopup;
